import {useQuery} from 'react-query'
import {AutomationEditForm} from './AutomationEditForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getSingleAutomation} from '../core/_requests'
import { useCompanies } from '../../../../auth/core/Companies'

const AutomationEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {defaultCompany} = useCompanies()

  const {
    isLoading,
    data: trigger,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getSingleAutomation(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <AutomationEditForm isUserLoading={isLoading} automation={{_id: undefined}} />
  }

  if (!isLoading && !error && trigger) {
    return <AutomationEditForm isUserLoading={isLoading} automation={trigger} />
  }

  return null
}

export {AutomationEditModalFormWrapper}
